export default class Achievements {
	allAchievements = undefined;
	onNewAchievement = undefined;

	constructor(data) {
		this.allAchievements = data;

		this.onNewAchievement = function () { };
	}

	/**
	 * @param {UserData} user
	 * @param {string} achievementName
	 * @returns {void}
	 */
	awardAchivement(user, achievementName) {
		if (!user.achievements) {
			user.achievements = [];
		}

		if (!user.items) {
			user.items = [];
		}

		const userHasAchievement = user.achievements.indexOf(achievementName) !== -1;

		if (userHasAchievement) {
			return;
		}

		let achievement = this.getAchievement(achievementName);

		if (!achievement) {
			achievement = {
				name: achievementName,
				category: '',
				title: achievementName,
				description: '',
				points: 25,
			};
		}

		const points = achievement.points;
		const item = achievement.item;
		//award achievement
		user.achievements.push(achievement.name);

		//award coins
		if (points) {
			user.coins = (Number(user.coins) ?? 0) + Number(points);
		}

		//award item
		if (item) {
			if (!user.items.includes(item)) {
				user.items.push(item);
			}
		}

		if (this.onNewAchievement) {
			this.onNewAchievement([achievement]);
		}

	}

	/**
	 * @param {UserData} user
	 * @param {StatsObject} stats
	 * @returns {any[]}
	 */
	checkForAchievementAndReward(user, stats) {
		if (!user.achievements) {
			user.achievements = [];
		}

		if (!user.items) {
			user.items = [];
		}

		if (!stats) {
			stats = user ?? {};
		}

		const achievements = this.checkForAchievement(user.achievements, stats);

		if (achievements.length === 0) {
			return;
		}

		//save achievements
		for (const achievement of achievements) {
			const points = achievement.points;
			const item = achievement.item;
			//award achievement
			user.achievements.push(achievement.name);

			//award coins
			if (points) {
				user.coins = (Number(user.coins) ?? 0) + Number(points);
			}

			//award item
			if (item) {
				if (!user.items.includes(item)) {
					user.items.push(item);
				}
			}
		}

		if (this.onNewAchievement) {
			//console.log('{"event":"achievement","value":' + JSON.stringify(achievements) + '}');
			this.onNewAchievement(achievements);
		}

		return achievements;
	}

	/**
	 * @param {string[]} currentAchievements
	 * @param {StatsObject} stats
	 * @returns {any[]}
	 */
	checkForAchievement(currentAchievements, stats) {
		const newAchievements = [];

		for (const achievement of this.allAchievements) {

			//check if user already has achievement
			if ((currentAchievements?.indexOf(achievement.name) !== -1)) {
				continue;
			}

			//check if any achievements have been achieved
			if (typeof achievement.check === 'function') {
				const pass = achievement.check(stats ?? {});

				if (pass === true) {
					newAchievements.push(achievement);
				}
			}
		}

		return newAchievements;
	}

	/**
	 * @param {string} name
	 * @returns {Achievement}
	 */
	getAchievement(name) {
		const achievements = this.allAchievements;
		return achievements.find((a) => a.name === name);
	}
}

/** @typedef {Achievement[]} AchievementConfig */

/**
 * @typedef {Object} StatsObject
 */
/**
 * @typedef {Object} Achievement
 * @property {string} name
 * @property {string} category
 * @property {string} title
 * @property {string} description
 * @property {number} points
 * @property {string} [image]
 * @property {boolean} [pushToFacebook]
 * @property {number} [order]
 * @property {(p: StatsObject) => boolean} [check]
 * @property {string} [item] 
 */
/**
 * @typedef {Object} UserData
 * @property {string[]} [achievements]
 * @property {string[]} [items]
 * @property {number} [coins] 
 */
